import { Menu } from '@syconium/little-miss-figgy'

import FilterMenu from '../../../../../../../../app/_components/menu/FilterMenu.client'
import { useTranslation } from '../../../../../../../../app/_providers/TranslationProvider.client'
import { useCollectionFilterQueryParamsContext } from '../../../../../../../../brunswick/containers/CollectionFilterQueryParamsContext'
import { FilterList } from '../../../../../../../../components/atoms/FilterList'
import { useCollectionFiltersContext } from '../../containers/CollectionFiltersContext'

import * as Styles from './styles'

/** The desktop filter menubar. */
export const DesktopFilterNav = ({
  disabled = false,
  hideOnClick = false,
}: {
  hideOnClick?: boolean
  disabled?: boolean
}) => {
  const { filters, totalItemsCount } = useCollectionFiltersContext()
  const { totalNumberOfSelectedFilterValues } = useCollectionFilterQueryParamsContext()
  const {
    magnolia: {
      account: { total },
    },
  } = useTranslation()

  return (
    <Styles.Body>
      <Styles.Menubar>
        {filters?.map(filter => (
          <FilterMenu.Provider key={filter.name}>
            <FilterMenu.MenubarButton disabled={disabled}>
              {filter.displayValue}
            </FilterMenu.MenubarButton>
            <FilterMenu.Menu>
              <FilterList.List count={filter.values.length}>
                {filter.values.map(filterValue => (
                  <Menu.MenuItem
                    key={filterValue.value}
                    hideOnClick={hideOnClick}
                    render={
                      filterValue.__typename === 'ProductCatalogProductColorFilterValue' ? (
                        <FilterList.ColorItem
                          filterKey={filter.name}
                          filterValue={filterValue}
                          asLink={filter.crawlable && totalNumberOfSelectedFilterValues === 0}
                        />
                      ) : (
                        <FilterList.CheckboxItem
                          filterKey={filter.name}
                          filterValue={filterValue}
                          asLink={filter.crawlable && totalNumberOfSelectedFilterValues === 0}
                        />
                      )
                    }
                  />
                ))}
              </FilterList.List>
            </FilterMenu.Menu>
          </FilterMenu.Provider>
        ))}
      </Styles.Menubar>
      {totalItemsCount && totalItemsCount > 0 ? (
        <Styles.Label>
          {totalItemsCount} {total}
        </Styles.Label>
      ) : null}
    </Styles.Body>
  )
}
